import { parseDate } from '@/helpers/time'
import { Log } from '@/types/logs'
import { OfficialReportType } from '@/types/officialReport'
import { isLateOfficialReportType, isHeadwayOfficialReportType, isGenericOfficialReportType } from './checkReportType'
import { OFFICIAL_REPORT_FORM_FIELDS } from '../constant'

export const generateOfficialReportDefaultValues = (log: Log, type: OfficialReportType): Record<string, unknown> => {
    const incidentDate = parseDate(log.report?.incidentDate || log.timestamp)

    const driverStatement = log.report?.driverStatement || ''

    const defaultValues: Record<string, unknown> = {
        [OFFICIAL_REPORT_FORM_FIELDS.dateOfIssue]: incidentDate.date,
        [OFFICIAL_REPORT_FORM_FIELDS.timeOfIssue]: incidentDate.time,
        [OFFICIAL_REPORT_FORM_FIELDS.driverEmployeeNumber]: log.report?.driverBadgeNumber || '',
        [OFFICIAL_REPORT_FORM_FIELDS.locationOfIssue]: log.report?.issueLocation || '',
        [OFFICIAL_REPORT_FORM_FIELDS.details]: isGenericOfficialReportType(type) ? (log.report?.description || '') : '',
        [OFFICIAL_REPORT_FORM_FIELDS.driverStatement]: driverStatement,
    }

    if (isLateOfficialReportType(type)) {
        const takeoverDate = log.report?.takeOverDate && parseDate(log.report?.takeOverDate)
        const actualTakeoverDate = log.report?.actualTakeOverDate && parseDate(log.report?.actualTakeOverDate)

        takeoverDate && (defaultValues[OFFICIAL_REPORT_FORM_FIELDS.takeoverTime] = takeoverDate.time)
        actualTakeoverDate && (defaultValues[OFFICIAL_REPORT_FORM_FIELDS.actualTakeoverTime] = actualTakeoverDate.time)
        defaultValues[OFFICIAL_REPORT_FORM_FIELDS.timeType] = log.report?.takeOverTimeMode || undefined
    }

    if (isHeadwayOfficialReportType(type)) {
        const mappedHeadways =
            log.report?.headways.map((item) => ({
                ...item,
                headway: item.headway.toString(),
                observedAt: parseDate(item.observedAt).time,
            })) ?? []
        // Always include a trailing empty row so the mount effect in Headway.tsx
        // never needs to append one, which would dirty the form immediately.
        defaultValues[OFFICIAL_REPORT_FORM_FIELDS.headways] = [
            ...mappedHeadways,
            { headway: '', busStop: '', observedAt: '' },
        ]
    }

    return defaultValues
}
